import React from 'react'

const InfoTab = () => {
    return (
        <div>InfoTab</div>
    )
}

export default InfoTab